import { render, staticRenderFns } from "./formTrailerData.vue?vue&type=template&id=4673465a&scoped=true"
import script from "./formTrailerData.vue?vue&type=script&lang=js"
export * from "./formTrailerData.vue?vue&type=script&lang=js"
import style0 from "./formTrailerData.vue?vue&type=style&index=0&id=4673465a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4673465a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4673465a')) {
      api.createRecord('4673465a', component.options)
    } else {
      api.reload('4673465a', component.options)
    }
    module.hot.accept("./formTrailerData.vue?vue&type=template&id=4673465a&scoped=true", function () {
      api.rerender('4673465a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transport/trailer/components/form/steps/formTrailerData.vue"
export default component.exports